import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios';
import { Button } from '@mui/material';


function CSVExport(props) {
    const [ file, setFile ] = useState();
    const [ user_id, setUser_id ] = useState(props.user_id);
    const [ class_id, setClass_id ] = useState(props.class_id);

    const hiddenFileInput = useRef(null);

    const exportGroups = async() => {
        
        axios.get(`${process.env.REACT_APP_API_HOST}/api/csv/groupsCSV/${class_id}`,
        { headers: {Authorization: `Bearer ${props.token.access_token}`}}
        )
        .then(res => res.data)
        .then(data => {
            
            const students = data.students.sort((a, b) => (a.last_name > b.last_name) ? 1: -1);
            
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += "name, canvas_user_id, user_id, login_id, sections, group_name, canvas_group_id, group_id \r\n";
            data.students.forEach(function(rowArray) {
              let row = 
                '\"' + rowArray.last_name+', '+ rowArray.first_name + '\",' +
                rowArray.canvas_id + "," + 
                rowArray.ucf_id + "," +
                rowArray.canvas_username + "," + 
                rowArray.section + "," + 
                rowArray.project_name + ",";
              csvContent += row + "\r\n";
            });
    
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "Project_Teams.csv");
            document.body.appendChild(link); // include in page
            
            link.click();
              
        })
        .catch(err => console.log(err))

    }

    const handleClick = event =>{
        //allow sub button to act as input button
        hiddenFileInput.current.click();
    }

    useEffect(() => {

    }, [file])

    //can use fetch to get files on the server.

  return (
        
        <div id="upload-box">
            
            <Button onClick={handleClick} style={{width: '100%', backgroundColor: '#2E2E2E'}} variant='contained'>Export Roster</Button>

            <button ref={hiddenFileInput} style={{display:'none'}} onClick={exportGroups}>Export group roster</button>
            
        </div>

  )
}


export default CSVExport